


/*mv*/
const images = document.querySelectorAll('.mv-list-item');
const dots = document.querySelectorAll('.dot');
const mvList = document.querySelector('.mv-list');
let number = 0;
let startX = 0;
let endX = 0;

// 画像とドットを切り替える関数
function changeImage(nextIndex = (number + 1) % images.length) {
  images[number].classList.remove('active');
  dots[number].classList.remove('active');

  number = nextIndex;

  images[number].classList.add('active');
  dots[number].classList.add('active');
}

// ドットクリック時の画像切り替え
dots.forEach((dot, index) => {
  dot.addEventListener('click', () => {
    changeImage(index);
  });
});

// スワイプでの画像切り替え
mvList.addEventListener('touchstart', (e) => {
  startX = e.changedTouches[0].screenX;
});

mvList.addEventListener('touchend', (e) => {
  endX = e.changedTouches[0].screenX;

  if (startX > endX + 50) {
    // 左スワイプ → 次の画像
    changeImage();
  } else if (startX < endX - 50) {
    // 右スワイプ → 前の画像
    const prevIndex = (number - 1 + images.length) % images.length;
    changeImage(prevIndex);
  }
});

// 5秒ごとの自動切り替え
setInterval(() => {
  changeImage();
}, 5000);

// 初期状態（安全のため）
images[number].classList.add('active');
dots[number].classList.add('active');


/*charm*/
$(function () {
  $('.js-charm-list').slick({
    infinite: true,
    arrows: false,
    dots: true,
    dotsClass: 'slider-dots',
    variableWidth: true,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 2000 
  });
});

$(function () {
    $('.js-charm-list-03').slick({
      infinite: true,
      arrows: true,
      dots: true,
      dotsClass: 'slider-dots',
      variableWidth: true,
      centerMode:true,
      autoplay: true,
    autoplaySpeed: 2000 
  });
});

$(function () {
  $('.js-lineup-slider').slick({
    infinite: true,
    arrows: false,
    dots: true,
    dotsClass: 'slider-dots',
    variableWidth: true,
    centerMode: false,
    autoplay: true,
    autoplaySpeed: 2000
  });
});

/*photo*/
$(function () {
    $('.js-photo-list').slick({
      infinite: true,
      arrows: true,
      dots: true,
      dotsClass: 'slider-dots',
      variableWidth: true,
      centerMode: true,
  });
});
/*store*/
$(function () {
  $('.store-list-item .store-list-q').click(function () {
    $(this).next('.store-list-a').slideToggle();
    $(this).toggleClass('is-open');
  });
});

/*consaltant*/
$(function () {
  if (window.matchMedia("(max-width: 768px)").matches) {
    $('.js-understand-list').slick({
      infinite: true,
      arrows:false,
      dots: true,
      dotsClass: 'slider-dots',
      variableWidth: true,
      centerMode: true,
    });
  } else {
    $('.js-understand-list').slick({
      infinite: true,
      dots: true,
      arrows: false,
      dotsClass: 'slider-dots',
      variableWidth: true,
      centerMode: true,
    });
  }
});
/*グロナビ*/
document.addEventListener('DOMContentLoaded', (event) => {
  const navItems = document.querySelectorAll('.pc-nav-list-item');

  navItems.forEach(item => {
      item.addEventListener('click', function() {
          // すべてのアイテムからactiveクラスを削除
          navItems.forEach(i => i.classList.remove('active'));
          // クリックされたアイテムにactiveクラスを追加
          this.classList.add('active');

          // 対象のセクションまでスクロール
          const target = document.querySelector(this.dataset.target);
          if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
      });
  });
});


/*==============================================
フローティング
==============================================*/
var windowWidth = $(window).width();
var windowSm = 767;

$(window).scroll(function () {
  var scrollTop = $(window).scrollTop();
  var footerTop = $('.lp-footer').offset().top;
  var windowBottom = scrollTop + $(window).height();
  if (scrollTop > 400 && windowBottom < footerTop) {
    $('.floating').addClass('show');
  } else {
    $('.floating').removeClass('show');
  }
});

//アニメーション

var scrollAnimationClass = 'sa';
var scrollAnimationShowClass = 'show';
var triggerMarginDefault = 200;

var scrollAnimationElm = document.querySelectorAll('.' + scrollAnimationClass);
var scrollAnimationFunc = function() {
var dataMargin = scrollAnimationClass + '_margin';
var dataTrigger = scrollAnimationClass + '_trigger';
var dataDelay = scrollAnimationClass + '_delay';
for(var i = 0; i < scrollAnimationElm.length; i++) {
var triggerMargin = triggerMarginDefault;
var elm = scrollAnimationElm[i];
var showPos = 0;
if(elm.dataset[dataMargin] != null) {
triggerMargin = parseInt(elm.dataset[dataMargin]);
}
if(elm.dataset[dataTrigger]) {
showPos = document.querySelector(elm.dataset[dataTrigger]).getBoundingClientRect().top + triggerMargin;
} else {
showPos = elm.getBoundingClientRect().top + triggerMargin;
}
if (window.innerHeight > showPos) {
var delay = (elm.dataset[dataDelay])? elm.dataset[dataDelay] : 0;
setTimeout(function(index) {
scrollAnimationElm[index].classList.add('show');
}.bind(null, i), delay);
}
}
}
window.addEventListener('load', scrollAnimationFunc);
window.addEventListener('scroll', scrollAnimationFunc);

/* countdown */
document.addEventListener('DOMContentLoaded', function () {
  const day = document.getElementById('countdown-day');
  const hour = document.getElementById('countdown-hour');
  const min = document.getElementById('countdown-min');
  const sec = document.getElementById('countdown-sec');

  if (!day || !hour || !min || !sec) {
    return;
  }

  function countdown() {
    const now = new Date();
    const deadline = new Date(2026, 5, 30, 23, 59, 0);
    const diff = Math.max(0, deadline.getTime() - now.getTime());

    const calcDay = Math.floor(diff / 1000 / 60 / 60 / 24);
    const calcHour = Math.floor(diff / 1000 / 60 / 60) % 24;
    const calcMin = Math.floor(diff / 1000 / 60) % 60;
    const calcSec = Math.floor(diff / 1000) % 60;

    day.innerHTML = calcDay < 10 ? '0' + calcDay : calcDay;
    hour.innerHTML = calcHour < 10 ? '0' + calcHour : calcHour;
    min.innerHTML = calcMin < 10 ? '0' + calcMin : calcMin;
    sec.innerHTML = calcSec < 10 ? '0' + calcSec : calcSec;
  }

  countdown();
  setInterval(countdown, 1000);
});
